module.exports = require("reselect");


//////////////////
// WEBPACK FOOTER
// external "reselect"
// module id = 433
// module chunks = 0